import { guarantees, validationSection } from '@/content/site'

import { Reveal } from './shared/Reveal'
import { SectionHeading } from './shared/SectionHeading'

export function ValidationSection() {
  return (
    <section id="validation" className="relative py-20 md:py-28">
      <div className="shell">
        <SectionHeading
          eyebrow={validationSection.eyebrow}
          title={validationSection.title}
          intro={validationSection.intro}
        />

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          {guarantees.map((g, i) => (
            <Reveal key={g.label} i={i} className="h-full">
              <article className="glass glass-rim glass-hi flex h-full flex-col p-6 md:p-7">
                <p
                  className="font-sans text-[2.4rem] font-semibold leading-none tracking-tight"
                  style={{
                    background: 'linear-gradient(135deg, #F4F2FF 20%, #A78BFA 100%)',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  {g.value}
                </p>
                <h3 className="mt-3 font-sans text-[1rem] font-semibold text-ink">{g.label}</h3>
                <p className="mt-2 font-paragraph text-[0.83rem] leading-relaxed text-ink-dim">
                  {g.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal i={3}>
          <p className="micro mt-6">
            Published thresholds — assets that fail a gate are not returned
          </p>
        </Reveal>
      </div>
    </section>
  )
}
